import React from 'react';
import { Icon, IconName } from 'app/common/components/controls';
import { forTemplate } from 'app/common/lib/util/i18n';
import { useFeatureFlag } from '@trello/feature-flag-client';
import { useBoardStatsQuery } from '@trello/graphql/generated';
import { asCompactNumber, asNumber } from 'app/common/lib/util/i18n/formatters';
import styles from './BoardMenuViewsAndCopies.less';

const format = forTemplate('board_menu_about_this_board');

export const ViewsAndCopies: React.FunctionComponent<{
  isTemplate: boolean;
  showLabels: boolean;
  copyCount: number;
  viewCount: number;
}> = ({ isTemplate, showLabels, copyCount, viewCount }) => {
  const shouldShowViewCopy =
    useFeatureFlag('teamplates.template-stats', false) && isTemplate;

  const copyText = copyCount === 1 ? format('copy') : format('copies');
  const viewText = viewCount === 1 ? format('view') : format('views');

  return (
    <div>
      {shouldShowViewCopy && (
        <div>
          <span
            className={styles.viewCopyText}
            title={`${asNumber(copyCount)} ${copyText}`}
          >
            <Icon
              name={IconName.Copy}
              small
              className={`${styles.iconViewCopy} icon-sm`}
            />
            {copyCount && asCompactNumber(copyCount)}
            &nbsp;
            {showLabels && copyText}
          </span>
          &nbsp;
          <span
            className={styles.viewCopyText}
            title={`${asNumber(viewCount)} ${viewText}`}
          >
            <Icon
              name={IconName.Subscribe}
              small
              className={`${styles.iconViewCopy} icon-sm`}
            />
            {viewCount && asCompactNumber(viewCount)}
            &nbsp;
            {showLabels && viewText}
          </span>
        </div>
      )}
    </div>
  );
};

export const BoardMenuViewsAndCopies: React.FunctionComponent<{
  idBoard: string;
  isTemplate: boolean;
  showLabels: boolean;
}> = ({ idBoard, isTemplate, showLabels }) => {
  const { data, error, loading } = useBoardStatsQuery({
    variables: { boardId: idBoard },
  });

  const shouldShowViewCopy =
    useFeatureFlag('teamplates.template-stats', false) && isTemplate;

  if (error || loading) {
    return null;
  }

  return (
    <div>
      {shouldShowViewCopy && (
        <div className={styles.viewCopyComponent}>
          <hr />
          <ViewsAndCopies
            isTemplate={isTemplate}
            showLabels={showLabels}
            copyCount={data?.board?.stats?.copyCount || 0}
            viewCount={data?.board?.stats?.viewCount || 0}
          />
          <hr />
        </div>
      )}
    </div>
  );
};
